<template>
  <div id="app">
    <router-view id="child"></router-view>
  </div>
</template>
<script>

export default {
  name: "App",
  data() {
    return {
      refreshing: false,
      // page: new Page(),
      startTime: 0,
      isMove: false,
      startY: 0,
      endY: 0,
      refreshDisabled: false,
    };
  },
  activated() {
    
  },
  mounted() {
    const child = document.getElementById('child')
    document.addEventListener("plusready", function () {
      var webview = plus.webview.currentWebview();
      plus.key.addEventListener("backbutton", function () {
        webview.canBack(function (e) {
          if (e.canBack) {
            webview.back(-1); //返回上一页
          } else {
            webview.close(); //关闭应用
          }
        });
      });
    });

    // 监听浏览器的popstate事件，处理手机左滑返回
    window.addEventListener('popstate', (event) => {
      // 在这里可以根据当前路由和业务需求进行处理
      // 例如，某些页面不允许返回，可以使用router.push保持在当前页面
      // 或者根据路由元信息进行控制
      const currentRoute = this.$router.currentRoute;
      
      // 示例：如果当前页面是登录页，阻止返回
      if (currentRoute.path === '/login') {
        // 使用replaceState来重置历史记录，防止再次触发
        history.replaceState(null, null, window.location.href);
        return;
      }
      
      // 示例：如果路由元信息中设置了noBack，则阻止返回
      if (currentRoute.meta && currentRoute.meta.noBack) {
        history.replaceState(null, null, window.location.href);
        return;
      }
      
      // 默认行为：允许返回
    });
  },
  methods: {

  },
};
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100vh;
  overflow: auto;
  // #child{
  //   height: 100%;
  //   overflow: hidden;
  // }
  #child{
    height: 100%;
  }
}

.van-pull-refresh {
  height: calc(100vh - 10px) !important;
  overflow: auto !important;
}

#refresh-indicator {
  position: fixed;
  top: -50px;
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  transition: top 0.3s ease-in-out;
  z-index: 999999999;
}

#refresh-indicator.visible {
  top: 0;
}

.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.text {
  margin-left: 10px;
}

.van-pull-refresh {
  height: 100vh;
  overflow: auto !important;
}
</style>
